/* eslint-disable */
document.addEventListener("DOMContentLoaded", () => {
  const handleContactAction = (event, addAction) => {
    event.preventDefault();
    const link = event.target;
    const url = link.getAttribute("href");
    if (!url) {
      console.error("Missing URL");
      return;
    }

    const linkText = link.innerHTML;
    link.innerHTML = "Aktualisiere...";

    fetch(url, {method: "POST"})
      .then((response) => {
        if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
        link.innerHTML = linkText;
        return response.body;
      })
      .then(() => {
        const parentElement = link.closest(".contact-person-card");
        if (!parentElement) return;
        const container = document.querySelector(".contact-person-cards[data-jsremove='true']");

        if (addAction) {
          link.classList.add("d-none");
          parentElement.querySelector(".js-contact-remove").classList.remove("d-none");

          if (container) {
            const clonedCard = parentElement.cloneNode(true);
            clonedCard.querySelector(".js-contact-add").classList.add("d-none");
            clonedCard.querySelector(".js-contact-remove").classList.remove("d-none");
            container.appendChild(clonedCard);
          }
        } else {
          const removeButton = document.querySelector('.wrapper .contact-person-card[data-uid="' + parentElement.dataset.uid + '"] .js-contact-remove');
          if (removeButton) {
            removeButton.classList.add("d-none");
          }
          parentElement.querySelector(".js-contact-add").classList.remove("d-none");
          const addButton = document.querySelector('.wrapper .contact-person-card[data-uid="' + parentElement.dataset.uid + '"] .js-contact-add');
          if (addButton) {
            addButton.classList.remove("d-none");
          }

          if (container) {
            const cardToRemove = container.querySelector('.contact-person-card[data-uid="' + parentElement.dataset.uid + '"]');
            if (cardToRemove) {
              cardToRemove.remove();
            }
          }
        }
      })
      .catch((error) => console.error("Fehler:", error));
  };

  document.body.addEventListener("click", (event) => {
    if (event.target.matches(".js-contact-remove")) {
      handleContactAction(event, false);
    } else if (event.target.matches(".js-contact-add")) {
      handleContactAction(event, true);
    }
  });
});
